import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import useTranslation from '@/hooks/useTranslation';

interface ConfirmCancelInvitationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  email: string;
  isLoading?: boolean;
}

export function CancelInvitationToOrgModal({
  isOpen,
  onClose,
  onConfirm,
  email,
  isLoading = false,
}: ConfirmCancelInvitationModalProps) {
  const { lang } = useTranslation();

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="sm:max-w-[425px]">
        <AlertDialogHeader>
          <AlertDialogTitle>{lang.get('msg.confirmCancelInviteTitle')}</AlertDialogTitle>
          <AlertDialogDescription className="text-dark-text">
            {lang.get('msg.confirmCancelInviteDescriptionPrefix')}
            <strong>{email}</strong>
            {lang.get('msg.confirmCancelInviteDescriptionSuffix')}
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="mt-5">
          <AlertDialogCancel onClick={onClose} disabled={isLoading}>
            {lang.get('msg.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-red-600 hover:bg-red-700"
          >
            {lang.get('msg.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
